import React, { useState } from 'react';
import { useNavigate, createSearchParams } from 'react-router-dom';
import { Box, TextField, IconButton, Select, MenuItem, FormControl } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useCategories } from '../hooks/useCategories';

const HeaderSearchForm = () => {
  const navigate = useNavigate();
  const categories = useCategories();

  const [searchQuery, setSearchQuery] = useState({
    product_name: '',
    category_id: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSearchQuery(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const filtered = Object.fromEntries(
      Object.entries(searchQuery).filter(([_, v]) => v !== '')
    );

    navigate({
      pathname: '/products',
      search: `?${createSearchParams(filtered)}`
    });
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{
        display: 'flex',
        alignItems: 'center',
        bgcolor: '#f5f6f7',
        borderRadius: 999,
        width: '100%',
        maxWidth: 900
      }}
    >
      {/* カテゴリセレクト */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          px: 1,
          mr: 1,
          borderRight: '1px solid',
          borderColor: 'divider',
          minWidth: 120
        }}
      >
        <FormControl fullWidth size="small">
          <Select
            value={searchQuery.category_id || ''}
            displayEmpty
            onChange={(e) =>
              setSearchQuery(prev => ({
                ...prev,
                category_id: e.target.value
              }))
            }
            sx={{
              backgroundColor: 'transparent',
              border: 'none',
              '&.MuiOutlinedInput-root': {
                '& fieldset': { border: 'none' },
                '&:hover fieldset': { border: 'none' },
                '&.Mui-focused fieldset': { border: 'none' },
              },
              '.MuiSelect-select': {
                display: 'block',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              },
            }}
          >
            <MenuItem value="">
              <em>すべて</em>
            </MenuItem>

            {categories.map((cat) => (
              <MenuItem
                key={cat.category_id}
                value={cat.category_id}
                sx={{
                  pl: cat.level * 2 + 2,
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word'
                }}
              >
                {cat.category_name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      {/* 商品名入力 */}
      <TextField
        name="product_name"
        value={searchQuery.product_name}
        onChange={handleChange}
        placeholder="商品名で検索"
        variant="standard"
        fullWidth
        InputProps={{ disableUnderline: true }}
        sx={{ flex: 1, minWidth: 0 }}
      />

      <IconButton type="submit" size="small" sx={{ mr: 1 }}>
        <SearchIcon />
      </IconButton>
    </Box>
  );
};

export default HeaderSearchForm;